import React, { useState, useEffect } from 'react';
import { DropDown, DropDownItem } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { generateImageSource } from '../../../utils/generateImageSource';
import './MobileDashboardSorting.scss';

const MobileDashboardSorting = ({
  sort, setSort, options, placeholder, testId, headerClass
}) => {
  const [header, setHeader] = useState(placeholder || 'Sort By');

  const handleSortChange = (headerDetails) => {
    setHeader(headerDetails.headerText);
    setSort(headerDetails.sort);
  };

  useEffect(() => {
    let option;
    if (sort && sort.by && sort.order) {
      option = options.find((it) => it.sort.by === sort.by && it.sort.order === sort.order);
      if (option) {
        setHeader(option.headerText);
      }
    } else if (sort) {
      option = options.find((it) => it.sort === sort);
    }
    if (option) {
      setHeader(option.headerText);
    }
  }, [sort, options]);

  const renderHeader = () => (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <img className="mobile-dashboard-sorting__header-icon" src={generateImageSource('/images/v1/path-to-pro/sort_icon.svg')} />
      <span className={`mobile-dashboard-sorting__header-text ${headerClass}`} data-testid="sort-header">{header}</span>
    </span>
  );

  return (
    <div data-testid={testId}>
      <DropDown
        header={renderHeader()}
        hideOnSelection
        expandOnClick
        onClick={(e) => e.stopPropagation()}
      >
        {options.length
          && options.map((it, i) => (
            <DropDownItem key={i} onClick={() => handleSortChange(it)}>
              <span className="mobile-dashboard-sorting__option-text" data-testid={`sort-option-${i}`}>{it.headerText}</span>
            </DropDownItem>
          ))}
      </DropDown>
    </div>
  );
};

MobileDashboardSorting.propTypes = {
  sort: PropTypes.shape({
    by: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  setSort: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    headerText: PropTypes.string,
    sort: PropTypes.shape({
      by: PropTypes.string,
      name: PropTypes.string
    })
  })).isRequired,
  testId: PropTypes.string,
  placeholder: PropTypes.string
};

MobileDashboardSorting.defaultProps = {
  placeholder: 'Sort By',
  testId: 'mobile-sort-dropdown'
};

export default MobileDashboardSorting;
